export enum ActivityEventType {
  NotDefined = 0,

  // Request
  RequestCreated = 1,
  RequestProcurementResponsibleAssigned = 2,
  RequestReviewedAndShared = 3,
  WaitingOn = 4,
  RequestApproved = 5,
  RequestRejected = 6,
  RequestApprovedOnBehalf = 7,
  RequestApproverChanged = 8,
  RequestRequesterChanged = 9,
  RequestInterviewManagerChanged = 10,
  RequestSourcingDeadlineExtended = 11,
  RequestCanceled = 12,

  // Candidates + consultant
  CandidateNominated = 13,
  CandidateMovedToInterview = 14,
  CandidateSelected = 15,
  CandidateNotSelected = 16,
  CandidateWithdrawn = 17,
  ConsultantCreated = 18,
  ConsultantAddedFromRequest = 19,
  ConsultantStatusUpdated = 20,
  ConsultantExtended = 21,

  // Rate negotiation
  NegotiationStarted = 22,
  NegotiationRateAgreed = 23,
  NegotiationRateRejected = 24,

  // Contract
  ContractCreatedAndShared = 25,
  ContractTermsApproved = 26,
  ContractTermsRejected = 27,
  ContractSigned = 28,
  ContractStatusUpdated = 29,
  ContractApprovedOnBehalf = 30,
  ContractApproverChanged = 31,

  // Extension
  ExtensionRequested = 32,
  ExtensionReviewedAndShared = 33,
  ExtensionTermsNegotiationStarted = 34,
  ExtensionTermsAgreed = 35,
  ExtensionTermsRejected = 36,

  // Request close
  RequestClosed = 37,

  // Consultant created by the assignment migration (FLEX-3501)
  ConsultantCreatedFromAssignment = 38,

  // Request reopen (FLEX-3617)
  RequestReopened = 39,
  NegotiationTermsEdited = 40,
  SigneeAddedToTheContract = 41,
  SigneeChanged = 42,
  SigneeRemoved = 43,
  SignatureProvidedBy = 44,
  SigneesFirstlyAdded = 45,
}
